const routerArr = [
  {
      path: '/initTrainingIdx',
      name: 'initTrainingIdx',
      meta: { title:'初级培训',login:true },
      component: () => import(/* webpackChunkName: 'initTraining' */ './page/initTrainingIdx.vue'),
  },
  {
      path: '/personalInforWrite',
      name: 'personalInforWrite',
      meta: { title:'信息填报' ,login:true},
      component: () => import(/* webpackChunkName: 'initTraining' */ './page/personalInforWrite.vue'),
  },
  {
    path: '/checkResult',
    name: 'checkResult',
    meta: { title:'审核结果' ,login:true},
    component: () => import(/* webpackChunkName: 'initTraining' */ './page/checkResult.vue'),
  },
  {
    path: '/userProtocal',
    name: 'userProtocal',
    meta: { title:'培训服务协议' ,login:true},
    component: () => import(/* webpackChunkName: 'initTraining' */ './page/userProtocal.vue'),
  },
  {
    path: '/initTrainProtocol',
    name: 'initTrainProtocol',
    meta: { title:'培训服务协议' ,login:false},
    component: () => import(/* webpackChunkName: 'initTraining' */ './page/initTrainProtocal.vue'),
  }
]
export default routerArr